module.exports = __webpack_public_path__ + "img/zhaichangfenxi.738df779.svg";